import React, { useState, useRef } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { GetFingerPrint } from 'Components/FingerPrintProcessing';
import { SenderRegistorEKYCBank2 } from 'Components/Api/PaysprintDMTAPI';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { Container, Grid, Paper, Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import { useLocation } from 'react-router-dom';
import HOCLoader from 'Components/Loader/HOCLoader';
import { makeStyles } from '@material-ui/core/styles';
import { PrimaryButton } from 'Components/Inputes/CustomButton';

const CustomContainer = HOCLoader(Container);

export const SenderEKYCBank2 = () => {
    const commonTabStyle = makeStyles({
        selectedTab: {
            backgroundColor: '#ff0000',
            color: 'white'
        }
    });
    const formRef = useRef();
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();
    const SenderMobile = location?.state?.Mobile;
    const StateResp = location?.state?.StateResp;
    const AadharNo = location?.state?.AadharNo;
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const Pipe = location?.state?.Pipe;
    const [formObject, setFormObject] = useState({
        SenderMobile: SenderMobile,
        StateResp: StateResp,
        WADH: 'E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=',
        Data: ''
    });

    const submitHandle = async (values) => {
        setResponseMessage('');

        setLoading(true);
        const { status, xmldata } = await GetFingerPrint(values.WADH);

        if (status === false) {
            alert(xmldata);
            return;
        }
        let fingerPrintXML = xmldata;

        const inputObj = {
            Mobile: values.SenderMobile,
            OTP: values.OTP,
            StateResp: values.StateResp,
            Data: fingerPrintXML,
            Pipe: Pipe,
            AadharNo: AadharNo
        };

        var reqObj = JSON.stringify(inputObj);
        var response = await SenderRegistorEKYCBank2(reqObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        var result = JSON.parse(response.data);
        setSeverity('success');
        setResponseMessage(result.Message);
        setIsError(true);
        let params = {
            Mobile: values.SenderMobile,
            Pipe: Pipe
        };
        history.push('/PS_SenderSearch', params);
    };

    const FormValidationSchema = Yup.object({
        SenderMobile: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'mobile')
            .length(10, PLEASE_PROVIDE_VALID + 'mobile')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submitHandle}
                resetForm={formObject}
            >
                {({ values, errors, setFieldValue }) => {
                    return (
                        <Form>
                            <Grid
                                item
                                container
                                margin="normal"
                                xs={12}
                                md={12}
                                sm={12}
                                lg={12}
                                spacing={2}
                                style={{
                                    justifyContent: 'center'
                                }}
                            >
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    {/* <h2 className={classes.PaperHead_h2}>
                                        Customer E-KYC
                                    </h2> */}

                                    <h2
                                        className={classes.PaperHead_h2}
                                        style={{
                                            marginBottom: '16px',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}
                                    >
                                        Customer E-KYC{' '}
                                        <b style={{ marginLeft: '100px' }}>
                                            Pipe
                                        </b>
                                        : {Pipe}{' '}
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Mobile Number"
                                                        name="SenderMobile"
                                                        type="text"
                                                        length={10}
                                                        placeholder="Mobile Number"
                                                        readOnly={true}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="OTP"
                                                        name="OTP"
                                                        type="text"
                                                        length={12}
                                                        placeholder="OTP"
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>

                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                                style={{
                                                    display: 'flex',
                                                    gap: '30px'
                                                }}
                                            >
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => {
                                                        history.push(
                                                            '/PS_SenderAadharVerifyBank2',
                                                            {
                                                                Mobile: SenderMobile,
                                                                Pipe: Pipe
                                                            }
                                                        );
                                                    }}
                                                    style={{
                                                        width: '180px'
                                                    }}
                                                >
                                                    Back
                                                </Button>
                                                <PrimaryButton
                                                    type="submit"
                                                    title="Continue to Scan"
                                                    style={{
                                                        width: '180px'
                                                    }}
                                                    className={
                                                        classes.CustomDMTButtonStyle
                                                    }
                                                    disabled={loading}
                                                />
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </CustomContainer>
    );
};
